import React from 'react'
import {SearchToSelect, Selection, Selector} from "../../../components/index";
import PropTypes from "prop-types"
import CountryStore from './CountryStore'
import {countryLooselyMatches} from "./util";


export class CountrySelector extends React.Component {

  static propTypes = {
    selected: PropTypes.any,
    selectByKey: PropTypes.bool,
    addCustom: PropTypes.bool,
    onSelected: PropTypes.func.isRequired

  }

  state = {
    customCountry: undefined
  }


  getSearchResults = ({ query, offset }) => {

    return CountryStore.onceLoaded().then(() => {
      let custom = this.state.customCountry
      const countries = CountryStore.countries.concat(custom ? [custom] : [])
      return countries.filter(country => {
        return countryLooselyMatches(query, country)
      }).sort((a, b) => a.name.localeCompare(b.name))
    })

  }

  resolveIds = (ids) => {
    let custom = this.state.customCountry
    return Promise
      .all(ids.map(x => {

        if (custom && custom.id === x) {
          return Promise.resolve(custom)
        } else {
          return CountryStore.resolve(x)
        }

      }))
      .then(xs => xs.filter(x => !!x))
  }

  addCustomCountry = text => {
    console.log('add cust')
    CountryStore.resolve(text)
      .then(resolved => {
        let resolvedOrAdded = resolved
        if (!resolved) {
          resolvedOrAdded = CountryStore.adhoc(text)
          this.setState({ customCountry: resolvedOrAdded })
        }
        Selection({...this.props, getKey: this.getKey }).addSelection(Selector.toArray(this.props.selected), resolvedOrAdded)
      })
  }


  getKey = x => x.id;

  render() {
    const {addCustom, ...otherProps} = this.props

    return <SearchToSelect
      getSearchResults={this.getSearchResults}
      getKey={this.getKey}
      resolveSelection={this.resolveIds}
      onForceSelect={addCustom ? this.addCustomCountry : undefined}
      disableCaching
      {...otherProps}
      renderOption={country => country.name}
    />
  }
}